<template>
  <div>
    <el-select
      v-model="childValue"
      class="h-40 mw-240 w-100p"
      :placeholder="placeholder"
      :disabled="disabled"
      clearable
      :filterable="filterable || type == KEY_REMOTE"
      :remote="type == KEY_REMOTE"
      :remote-method="getOptionsData"
      @input="change"
      v-if="!isLink">
      <el-option
        v-for="item in efficientOptions"
        :label="item.name"
        :value="item.id"
        v-show="!item.disabled">
      </el-option>
    </el-select>
    <el-cascader
      class="h-40 mw-240 w-100p"
      :options="linkOptions"
      v-model="childValue"
      :filterable="filterable"
      clearable
      :show-all-levels="false"
      :disabled="disabled"
      :props="props"
      clearable
      @input="change"
      @active-item-change="handleItemChange"
      v-if="isLink">
    </el-cascader>
  </div>
</template>
<script>
  /**
   * @param Number value 绑定值
   * @param Number id 控件id
   * @param String name 控件名
   * @param Boolean filterable 是否可筛选
   * @param Boolean disabled 是否禁用
   * @param Array efficientOptions 生效的选项
   * @param String majorField 显示的主字段
   * @param Array depentField 从属字段
   * @param Number type 控件类型
   * @param Number isLink 是否级联形式
   * @param Number linkField 级联关联字段
   */
  import modelConfig from '../../../../config/modelConfig'
  import http from '../../../../assets/js/http'
  export default {
    props: ['value', 'id', 'name', 'filterable', 'disabled', 'efficientOptions', 'majorField', 'depentField', 'type', 'keyCascade', 'keyFillin', 'keyItem', 'isLink', 'linkField', 'keyFilter', 'hasNull'],
    data() {
      return {
        childValue: null,
        placeholder: '请选择',
        allOptions: [],
        linkOptions: [], // 级联类型的选项
        props: {
          value: 'id',
          label: 'name',
          children: 'children'
        },
        getOptionCounter: 0,
        forignList: [],
        nullOption: [{ id: 0, value: 0, name: '无' }]
      }
    },
    methods: {
      async initData() {
        if (!this.isLink) { // 非级联
          if (!_g.isRealEmpty(this.value)) {
            this.childValue = this.value
          } else {
            this.childValue = ''
          }
        } else {
          if (_g.isRealEmpty(this.value)) {
            this.childValue = []
          } else {
            this.childValue = []
            let fullValue = await this.getParentByChild(this.value)
            fullValue.push(this.value)
            setTimeout(() => {
              this.childValue = fullValue
              this.getOptionCounter++
            })
          }
        }
      },
      makePostData(keyword) {
        let postData = {}
        if (this.majorField) {
          postData.major_field = this.majorField
        }
        if (this.depentField) {
          postData.depent_field = []
          _(this.depentField).forEach((res) => {
            postData.depent_field.push(res.name)
          })
        }
        // 填充数据请求提交
        postData.fillin_field = []
        if (this.keyFillin && this.keyFillin.length > 0) {
          _(this.keyFillin).forEach((res) => {
            if (res.fill_field && res.be_fill_field) {
              postData.fillin_field.push(res.fill_field)
            }
          })
        }
        // 增加
        postData.extra_field = []
        if (this.keyCascade && this.keyCascade.extra_field && this.keyCascade.major_field) {
          postData.extra_field.push(this.keyCascade.extra_field)
        }
        //
        postData.key_filter = []
        if (this.keyFilter && this.keyFilter.length > 0) {
          postData.key_filter = this.keyFilter
        }
        if (keyword) {
          postData.keyword = keyword
        }
        return postData
      },
      async getOptionsData(keyword) {
        let postData = this.makePostData(keyword)
        let data = await this.doPost(postData)
        if (data) {
          if (this.hasNull) {
            data.marjorData = Array.concat(this.nullOption, data.marjorData)
          }
          this.allOptions = data.marjorData
          this.keyItem.allOptions = data.marjorData
          this.$emit('setEfficientOptions', this.name, data.marjorData)
          // console.log(this.efficientOptions)
          this.efficientOptions = data.marjorData
          this.$emit('setKeyOptions', this.name, this.allOptions)
          this.$emit('setKeyData', this.name, data)
        }
        // this.apiPost(`form/keys/${this.id}`, postData).then((res) => {
        //   if (res.code == 200) {
        //     if (res.data) {
        //       _(res.data.marjorData).forEach((item) => {
        //         item.disabled = false
        //       })
        //       this.allOptions = res.data.marjorData
        //       this.keyItem.allOptions = res.data.marjorData
        //       this.efficientOptions = res.data.marjorData
        //       this.$emit('setKeyOptions', this.name, this.allOptions)
        //       this.$emit('setKeyData', this.name, res.data)
        //     }
        //   }
        // })
      },
      async doPost(postData) {
        let res = await this.apiPost(`form/keys/${this.id}`, postData)
        let data = this.promiseHandler(data, res)
        if (data) {
          _(data.marjorData).forEach((item) => {
            item.disabled = false
          })
        }
        return data
      },
      async getParentByChild(id) { // 根据子id找所有父id
        let postData = {
          params: {
            id: id
          }
        }
        let res = await this.apiGet(`form/keys/${this.id}/parents`, postData)
        let data = this.promiseHandler(data, res)
        return data
      },
      async handleItemChange(value) { // 根据父级请求子级
        this.childValue = value
        await this.getCurrentChildren(value)
        this.change()
      },
      async getCurrentChildren(value, change) {
        if (value && value.length) {
          let currentChildren = this.linkOptions
          let tempOption = null
          _(value).forEach((res) => {
            _(currentChildren).forEach((option) => {
              if (option.id == res) {
                tempOption = option
                return false
              }
            })
            if (tempOption) {
              currentChildren = tempOption.children
            }
          })
          if (tempOption &&
              _g.isRealEmpty(tempOption.children) &&
              tempOption.children != null) { // 如果子级数据还未请求且存在（不为null）
            let param = value[value.length - 1]
            let children = await this.getChildrenOptions(param)
            if (children && children.length) {
              tempOption.children = children
            } else {
              tempOption.children = null
            }
          }
        }
      },
      async getCurrentOption() {
        let arr = []
        for (let i = 0; i < this.childValue.length; i++) {
          let item = this.childValue[i]
          arr.push(item)
          await this.getCurrentChildren(arr)
        }
      },
      async getChildrenOptions(param) { // 级联找儿子
        let postData = this.makePostData()
        postData.link_param = param
        let data = await this.doPost(postData)
        if (data) {
          _(data.marjorData).forEach((res) => {
            res.children = []
          })
          if (!this.keyItem.fillData) {
            this.keyItem.fillData = {}
            this.keyItem.fillData[this.name] = {}
          }
          for (let key in data.fillinData) {
            this.keyItem.fillData[this.name][key] = data.fillinData[key]
          }
          // this.keyItem.fillData[this.name] = data.fillinData
          return data.marjorData
        } else {
          return []
        }
      },
      filterOptions() { // 筛选当前启用的选项
        if (this.efficientOptions) {
          _(this.allOptions).forEach((res) => {
            if (_.findIndex(this.efficientOptions, (item) => {
              return res.id == item || res.id == item.id
            }) > -1) {
              res.disabled = true
            } else {
              res.disabled = false
            }
          })
        } else {
          _(this.allOptions).forEach((res) => {
            res.disabled = false
          })
        }
      },
      change() {
        let outputValue = ''
        if (!this.isLink) {
          outputValue = this.childValue
        } else {
          if (this.childValue && this.childValue.length) {
            outputValue = this.childValue[this.childValue.length - 1]
          }
        }
        this.$emit('input', outputValue)
      }
    },
    async created() {
      this.initData()
      if (!this.isLink) {
        if (this.type == this.KEY_SELECT) {
          this.getOptionsData()
        } else if (this.type == this.KEY_REMOTE) {
          this.placeholder = '请输入关键字搜索选项'
        }
      } else {
        this.linkOptions = await this.getChildrenOptions()
        if (this.hasNull) {
          this.linkOptions = Array.concat(this.nullOption, this.linkOptions)
        }
        this.getOptionCounter++
      }
    },
    watch: {
      'value'() {
        if (!this.isLink) {
          if (this.value !== this.childValue) {
            this.initData()
          }
        } else {
          if (this.childValue &&
              this.childValue.length &&
              this.value != this.childValue[this.childValue.length - 1]) {
            this.initData()
          }
        }
      },
      'getOptionCounter'() {
        if (this.getOptionCounter == 2) {
          this.getCurrentOption()
        }
      }
    },
    mixins: [http, modelConfig]
  }
</script>


// WEBPACK FOOTER //
// honrayForeignkey.vue?7e868b3b